<custom-navbar barTitle="아이디 / 비밀번호 찾기" [showSetting]="false" [showBack]="false"></custom-navbar>
<div class="find-pw-wrap">
  <div class="box">
    <img src="assets/images/idpw_result_01.png">
    <div class="text">입력하신 전화번호로<br>SMS정보를 전송했습니다!</div>
    <button class="login-btn" mat-button (click)="moveLoginPage()">로그인</button>
  </div>
</div>
